var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "relation-order-info" } }, [
    _c("div", { staticClass: "order-info" }, [
      _c("p", [_vm._v("关联订单号：" + _vm._s(_vm.details.orderNo || "--"))]),
      _c("p", [
        _vm._v("来源平台：" + _vm._s(_vm.details.platformLabel || "--")),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "googs-sku-list" },
      [
        _vm.details.list && _vm.details.list.length > 0
          ? _vm._l(_vm.details.list, function (item, index) {
              return _c("p", [
                _c("span", [_vm._v(_vm._s(index + 1))]),
                _c(
                  "span",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.onCopySku(item.goodsSkuNo)
                      },
                    },
                  },
                  [_vm._v("SKU:" + _vm._s(item.goodsSkuNo))]
                ),
                _c("span", [_vm._v("商品名称：" + _vm._s(item.goodsName))]),
                _c("span", [
                  _vm._v(
                    "商品规格*数量：" +
                      _vm._s(item.skuName) +
                      "*" +
                      _vm._s(item.quantity)
                  ),
                ]),
                _c("span", [_vm._v("商品单价：" + _vm._s(item.unitPrice))]),
                _c("span", [_vm._v("商品合计：" + _vm._s(item.subtotal))]),
              ])
            })
          : [_c("p", { staticClass: "nothing" }, [_vm._v(" SKU暂无数据 ")])],
      ],
      2
    ),
    _c("div", { staticClass: "total" }, [
      _vm._v("订单总额："),
      _c("span", [_vm._v("￥" + _vm._s(_vm.details.totalAmount))]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }